import {Box, Button, Menu, MenuItem, Tooltip} from '@mui/material'
import {useState} from 'react'
import actionsObject from 'src/images/actionsObject.svg'
import Delete from 'src/images/deleteIconBlack.svg'
import IconEditUser from 'src/images/iconEditUser.svg'

type ServerTableOptionProps = {
  onClick: (event: string) => void
  hasUpdatePermission: boolean
  hasDeletePermission: boolean
}

export const ServerTableOption = (props: ServerTableOptionProps) => {
  const {onClick, hasUpdatePermission, hasDeletePermission} = props
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  return (
    <>
      <Tooltip title='Opções' placement='top'>
        <Button
          sx={{height: '26px', minWidth: '5px'}}
          onClick={(event) => {
            event.stopPropagation()
            setAnchorEl(event.currentTarget)
          }}>
          <img src={actionsObject} alt='Menu logo' style={{width: 20, height: 20}} />
        </Button>
      </Tooltip>
      <Menu
        id='fade-menu'
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            onClick('edit')
            setAnchorEl(null)
          }}
          disabled={!hasUpdatePermission}>
          <Box sx={{display: 'flex', justifyContent: 'center', gap: '10px', fontSize: '0.9em', alignItems: 'center'}}>
            <img src={IconEditUser} alt='Menu logo' style={{width: 16, height: 16}} />
            <Box sx={{fontFamily: 'Inter', paddingLeft: 0.9}}>Editar</Box>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onClick('delete')
            setAnchorEl(null)
          }}
          disabled={!hasDeletePermission}>
          <Box sx={{display: 'flex', justifyContent: 'center', gap: '10px', fontSize: '0.9em', alignItems: 'center'}}>
            <img src={Delete} alt='Menu logo' style={{width: 16, height: 16}} />
            <Box sx={{fontFamily: 'Inter', paddingLeft: 0.9}}>Deletar</Box>
          </Box>
        </MenuItem>
      </Menu>
    </>
  )
}
